// Dynamically load all emoji images from the QuagganEmojis folder structure.
const emojiContext = require.context(
  "../images/QuagganEmojis",
  true,
  /\.(webp|png|gif)$/i,
);

const categoryEmojiMetadata = {};

emojiContext.keys().forEach((key) => {
  const pathParts = key.split("/");
  const category = pathParts[1];
  const filename = pathParts[pathParts.length - 1];
  const name = filename.replace(/\.[^.]+$/, "");
  const imageModule = emojiContext(key);
  const src = imageModule.default || imageModule;

  if (!categoryEmojiMetadata[category]) {
    categoryEmojiMetadata[category] = [];
  }

  categoryEmojiMetadata[category].push({ name, src, category });
});

// Keep the existing public pools as image source arrays for compatibility.
const categoryPools = Object.fromEntries(
  Object.entries(categoryEmojiMetadata).map(([category, emojis]) => [
    category,
    emojis.map((emoji) => emoji.src),
  ]),
);

export const SUCCESS_EMOJIS = categoryPools.success || [];
export const FAILURE_EMOJIS = categoryPools.failure || [];
export const OTHER_EMOJIS = categoryPools.other || [];

const ALL_EMOJIS = Object.values(categoryEmojiMetadata).flat();

export const getEmojiPool = (categoryName) => {
  return categoryPools[categoryName] || [];
};

export const getAvailableCategories = () => {
  return Object.keys(categoryPools);
};

export const getAllPoolsMap = () => {
  return { ...categoryPools };
};

const hashString = (value) => {
  const text = String(value || "");
  let hash = 0;
  for (let index = 0; index < text.length; index += 1) {
    hash = (hash << 5) - hash + text.charCodeAt(index);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const pickQuagganEmoji = ({ type = "failure", seed } = {}) => {
  const pool =
    type === "success"
      ? SUCCESS_EMOJIS
      : type === "all"
        ? Object.values(categoryPools).flat()
        : FAILURE_EMOJIS;

  if (pool.length === 0) {
    return "";
  }

  if (seed === undefined || seed === null || seed === "") {
    return pool[Math.floor(Math.random() * pool.length)];
  }

  const selectedIndex = hashString(seed) % pool.length;
  return pool[selectedIndex];
};

export const getEmojiByName = (name) => {
  const normalizedName = String(name || "").toLowerCase();
  return ALL_EMOJIS.find((emoji) => emoji.name.toLowerCase() === normalizedName)?.src || "";
};
